export const enum PaginasIntermediariasEnum {
    CURSO_LIVRE = 'CURSO_LIVRE',
    SOCIOEMOCIONAL_PROFESSORES = 'SOCIOEMOCIONAL_PROFESSORES',
    REALIZANDO_ESCOLHAS = 'REALIZANDO_ESCOLHAS',
    CRIATIVIDADE_PENSAMENTO_CRITICO = 'CRIATIVIDADE_PENSAMENTO_CRITICO',
    ALFABETIZACAO_360 = 'ALFABETIZACAO_360',
    COMPETENCIAS_SOCIOEMOCIONAIS = 'COMPETENCIAS_SOCIOEMOCIONAIS',
    FAQ = 'FAQ',
}
